import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { handleJoinRequiresAbonement } from './abonementWizardEvents';
import {
  Player,
  PlayerPair,
  EmptyPlayer,
  EmptyPlayerSlot,
  PlayersCount,
  PlayersCountNoNum,
  PlayersInner,
  PlayersList,
  PlayersPairs,
  NoPlayersMessage,
  ActionButton,
  LoginButton,
  GameDetailsInnerRoot,
  GamePlayers,
  KingOfTheHillPlayers,
  KingOfTheHillResults,
  KingOfTheHillPrePlayers,
  MorningOpenPlayers,
  MorningOpenPrePlayers,
  RandomRelationsPlayers,
  RandomRelationsResults,
  RandomRelationsPrePlayers,
  RandomRelationsMiniPlayers,
  TrainingQueue,
  NoActionButton,
  GameDetailsInnerSummary,
  AlertInfo,
  AlertDanger,
  AlertPrepayment,
  AlertAfterReg,
  AlertTraining,
  EmailPopupModal
} from './final.js'; //




class GameDetails extends React.Component {

  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.state = {
        game: this.props.game,
        showEmailPopup: false,
        email: this.props.game.email,
        emailError: '',
        isOfferAccepted: this.props.game.isofferaccepted
    }
  }

  componentDidUpdate() {

        $.fn.matchHeight._update('.slots__item');

        if ($('.slots__item-place-user').length) {
            var width = $('.slots__item-place-user').first().width();

            //console.info(width);

            $('.slots__item-place-user').height(width);
        }

//        var scrollPosition = $(window).scrollTop();
  }


   addActionButtons = () => {
    var result = [];

    if (!this.state.game.isCompleted && !this.state.game.isUser) {   // если турнир завершен, кнопки не отображаются
        result.push(<LoginButton key="login" />);
    }

    if (!this.state.game.isCompleted && this.state.game.isUser && (this.state.game.eventType !== 'COMPETITION')) {    // если турнир завершен, кнопки не отображаются
        // Все типы игр. Записаться или Оплатить участие
        if (!this.state.game.isUserJoined && this.state.game.isJoiningAvailable) {
            let buttonTitle = (
              this.state.game.is_online_payment === "True" && !this.state.game.canRequestTrainingLevelApproval
            ) ? 'Оплатить участие' : 'Записаться';
            result.push(
              <ActionButton
                handler={(e) => this.handleClick(e, '/api/games/'+ this.state.game.id +'/join/' + this.state.game.name + '/')}
                key="join" title={buttonTitle} colorStyle={'btn-primary'}
                gameType={this.state.game.gameType}
              />
            );
        }
        // Все типы игр. Нет записи
        if (!this.state.game.isUserJoined && !this.state.game.isJoiningAvailable) {
        result.push(<NoActionButton key="no-join" message={this.state.game.buttonMessage} />);
        }
        // TRAINING, GAME. Запись друга (М, Ж)  this.state.game.eventType === 'TRAINING' ||
        if (this.state.game.isUserJoined && this.state.game.isJoiningAvailable && !this.state.game.isUserFriendJoined
            && (this.state.game.eventType === 'GAME')) {
            result.push(
            <div key="join-friend-buttons" className="d-flex">
              <ActionButton
                handler={(e) => this.handleJoinFriend(e, 'M')}
                key="join-friend-male" colorStyle="btn-primary mr-2"
                title="Записать мальчика"
                gameType={this.state.game.gameType}
              />
              <ActionButton
                handler={(e) => this.handleJoinFriend(e, 'W')}
                key="join-friend-female" colorStyle="btn-pink"
                title="Записать девочку"
                gameType={this.state.game.gameType}
              />
            </div>
            );
        }
        // TRAINING, GAME. Отписать друга
        if (this.state.game.isUserFriendJoined) {
          result.push(
            <ActionButton
              handler={(e) => this.handleLeave(e, '/api/games/' + this.state.game.id + '/leave/' + this.state.game.name + '/friend/')}
              key="leave-other-friend"
              title={'Отписать друга'}
              colorStyle={'btn-danger'}
              gameType={this.state.game.gameType}
            />
          );
        }
        // Все типы игр. Отписаться
        if (this.state.game.isUserJoined && !this.state.game.isUserFriendJoined) {
            result.push(
              <ActionButton
                handler={(e) => this.handleLeave(e, '/api/games/' + this.state.game.id + '/leave/' + this.state.game.name + '/')}
                key="leave" colorStyle="btn-danger"
                title="Отписаться"
                gameType={this.state.game.gameType}
              />
            );
        }
    }

    return result;
  }

  handleClick = (e, action, friendSex = null) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    if (
      action.includes('join')
      && this.state.game.is_online_payment === "True"
      && !this.state.game.canRequestTrainingLevelApproval
    ) {
      if (this.state.isOfferAccepted == "False") {
        this.setState({ pendingFriendSex: friendSex });
        this.openEmailPopup();
      } else {
        this.createTicket(friendSex);
      }
    } else {
      this.handleJoin(action);
    }
  }

  handleEmailChange = (e) => {
    this.setState({ email: e.target.value });
  }

  handleEmailSubmit = (email) => {
    const { game, pendingFriendSex } = this.state;
    const data = new URLSearchParams();
    data.append('email', email);
    data.append('game_time_slot_id', game.id);

    axios.post('/api/update_email/', data, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
    .then(res => {
      if (res.data.success) {
        const userEmail = email;

        this.setState({ showEmailPopup: false, emailError: '', isOfferAccepted: true, pendingFriendSex: null }, () => {
          if (!this.state.email) {
            this.setState({ email: userEmail }, () => {
              this.createTicket(pendingFriendSex);
            });
          } else {
            this.createTicket(pendingFriendSex);
          }
        });
      } else {
        this.setState({ emailError: 'Ошибка при обновлении email' });
      }
    });
  }

  createTicket = (friendSex = null) => {
    const { game, email } = this.state;
    const data = new URLSearchParams();
    data.append('game_time_slot_id', game.id);
    data.append('email', email);
    if (friendSex) {
      data.append('friend_sex', friendSex);
    }

    axios.post('/payments/create_event/', data, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
    .then(res => {
      if (res.data.success) {
        window.location.href = res.data.payment_url;
      } else {
        console.error('Ошибка при создании платежа:', res.data.error);
      }
    })
    .catch(err => {
      console.error('Ошибка при создании платежа:', err);
    });
  }

  // Функция для определения операционной системы и источника
  getOsAndSource = () => {
    // Определяем операционную систему
    let operating_system = null;
    const userAgent = navigator.userAgent;
    if (/Android/i.test(userAgent)) {
      operating_system = 'android';
    } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
      operating_system = 'ios';
    } else if (/Mac OS/i.test(userAgent)) {
      operating_system = 'macos';
    } else if (/Windows/i.test(userAgent)) {
      operating_system = 'windows';
    } else if (/Linux/i.test(userAgent)) {
      operating_system = 'linux';
    }
    
    // Определяем источник
    let source = 'website';
    if (/Mobile/i.test(userAgent) && !/iPad/i.test(userAgent)) {
      source = 'mobile_web';
    }
    
    // Проверяем webview
    if (/wv|WebView/i.test(userAgent)) {
      source = 'webview';
    }
    
    // Проверяем telegram/vk
    if (window.location.href.includes('telegram')) {
      source = 'telegram';
    } else if (window.location.href.includes('vk.com')) {
      source = 'vk';
    }
    
    return { operating_system, source };
  }

  handleJoin = (action) => {
    // Добавляем параметры ОС и источника
    const { operating_system, source } = this.getOsAndSource();
    const separator = action.includes('?') ? '&' : '?';
    const actionWithParams = `${action}${separator}operating_system=${operating_system}&source=${source}`;
    
    axios.get(actionWithParams)
      .then(joinRes => {
        if (handleJoinRequiresAbonement(joinRes)) {
          return;
        }
        if (joinRes.data && joinRes.data.message_type === 'warning' && joinRes.data.message) {
          window.alert(joinRes.data.message);
          return;
        }
        if (joinRes.data && joinRes.data.message_type === 'info') {
          window.alert(joinRes.data.message);
        }
        axios.get('/api/games/' + this.state.game.id + '/' + this.state.game.name + '/')
          .then(res => {
            this.setState(prevState => {
              var game = Object.assign({}, prevState.game);
              game.totalPlayersNum = res.data._total_players_num;
              game.totalPlayersQueuedNumNum = res.data._total_players_queued_num;
              game.totalPlayersWithPaymentNum = res.data._total_players_with_payment_num;
              game.totalPlayersWithoutPaymentNum = res.data._total_players_without_players_num;
              game.isJoiningAvailable = res.data._is_joining_available;
              game.canRequestTrainingLevelApproval = res.data._can_request_training_level_approval;
              game.isTrainingAdminJoiningAvailable = res.data._is_admin_joining_available;
              game.isUserJoined = res.data._is_user_joined;
              game.isUserFriendJoined = res.data._is_user_friend_joined;
              game.isUserPaid = res.data._is_user_paid;
              game.isSelfRegAvailable = res.data._is_self_reg_available;
              game.isSelfRegAvailableForPlayer = res.data._is_self_reg_available_for_player;
              game.players = res.data._players;
              game.playersQueued = res.data._players_queued;
              game.playersWithPayment = res.data._players_with_payment;
              game.playersWithoutPayment = res.data._players_without_payment;
              game.manPlayers = res.data._man_players;
              game.manPlayersWithPayment = res.data._man_players_with_payment;
              game.manPlayersWithoutPayment = res.data._man_players_without_payment;
              game.womanPlayers = res.data._woman_players;
              game.womanPlayersWithPayment = res.data._woman_players_with_payment;
              game.womanPlayersWithoutPayment = res.data._woman_players_without_payment;
              return { game };
            });
          });
      })
      .catch((error) => {
        const status = error && error.response && error.response.status;
        if (status === 403) {
          window.alert('Не удалось записаться. Перезайдите на сайт и попробуйте снова.');
          return;
        }
        window.alert('Не удалось записаться. Проверьте интернет и попробуйте снова.');
      });
  }

  handleLeave = (e, action) => {
    e.preventDefault();

    // Добавляем параметры ОС и источника
    const { operating_system, source } = this.getOsAndSource();
    const separator = action.includes('?') ? '&' : '?';
    const actionWithParams = `${action}${separator}operating_system=${operating_system}&source=${source}`;

    axios.get(actionWithParams)
      .then(res => {
        axios.get('/api/games/' + this.state.game.id + '/' + this.state.game.name + '/')
          .then(res => {
            this.setState(prevState => {
              var game = Object.assign({}, prevState.game);
              game.totalPlayersNum = res.data._total_players_num;
              game.totalPlayersQueuedNumNum = res.data._total_players_queued_num;
              game.totalPlayersWithPaymentNum = res.data._total_players_with_payment_num;
              game.totalPlayersWithoutPaymentNum = res.data._total_players_without_players_num;
              game.isJoiningAvailable = res.data._is_joining_available;
              game.canRequestTrainingLevelApproval = res.data._can_request_training_level_approval;
              game.isTrainingAdminJoiningAvailable = res.data._is_admin_joining_available;
              game.isUserJoined = res.data._is_user_joined;
              game.isUserFriendJoined = res.data._is_user_friend_joined;
              game.isUserPaid = res.data._is_user_paid;
              game.isSelfRegAvailable = res.data._is_self_reg_available;
              game.isSelfRegAvailableForPlayer = res.data._is_self_reg_available_for_player;
              game.players = res.data._players;
              game.playersQueued = res.data._players_queued;
              game.playersWithPayment = res.data._players_with_payment;
              game.playersWithoutPayment = res.data._players_without_payment;
              game.manPlayers = res.data._man_players;
              game.manPlayersWithPayment = res.data._man_players_with_payment;
              game.manPlayersWithoutPayment = res.data._man_players_without_payment;
              game.womanPlayers = res.data._woman_players;
              game.womanPlayersWithPayment = res.data._woman_players_with_payment;
              game.womanPlayersWithoutPayment = res.data._woman_players_without_payment;
              return { game };
            });
          });
      });
  }

  handleJoinFriend = (e, friendSex) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    const action = `/api/games/${this.state.game.id}/join/${this.state.game.name}/friend/${friendSex}/`;
    
    if (this.state.game.is_online_payment === "True") {
      this.handleClick(e, action, friendSex);
      return;
    }

    const { operating_system, source } = this.getOsAndSource();
    const separator = action.includes('?') ? '&' : '?';
    const actionWithParams = `${action}${separator}operating_system=${operating_system}&source=${source}`;

    axios.get(actionWithParams)
      .then(res => {
        axios.get('/api/games/' + this.state.game.id + '/' + this.state.game.name + '/')
          .then(res => {
            this.setState(prevState => {
              var game = Object.assign({}, prevState.game);
              game.totalPlayersNum = res.data._total_players_num;
              game.totalPlayersQueuedNumNum = res.data._total_players_queued_num;
              game.totalPlayersWithPaymentNum = res.data._total_players_with_payment_num;
              game.totalPlayersWithoutPaymentNum = res.data._total_players_without_players_num;
              game.isJoiningAvailable = res.data._is_joining_available;
              game.canRequestTrainingLevelApproval = res.data._can_request_training_level_approval;
              game.isTrainingAdminJoiningAvailable = res.data._is_admin_joining_available;
              game.isUserJoined = res.data._is_user_joined;
              game.isUserFriendJoined = res.data._is_user_friend_joined;
              game.isUserPaid = res.data._is_user_paid;
              game.isSelfRegAvailable = res.data._is_self_reg_available;
              game.isSelfRegAvailableForPlayer = res.data._is_self_reg_available_for_player;
              game.players = res.data._players;
              game.playersQueued = res.data._players_queued;
              game.playersWithPayment = res.data._players_with_payment;
              game.playersWithoutPayment = res.data._players_without_payment;
              game.manPlayers = res.data._man_players;
              game.manPlayersWithPayment = res.data._man_players_with_payment;
              game.manPlayersWithoutPayment = res.data._man_players_without_payment;
              game.womanPlayers = res.data._woman_players;
              game.womanPlayersWithPayment = res.data._woman_players_with_payment;
              game.womanPlayersWithoutPayment = res.data._woman_players_without_payment;
              return { game };
            });
          });
      });
  }

  playersBlock = (playersLabel) => {
    if(this.state.game.isKingOfTheHill || this.state.game.isRandomRelations || this.state.game.isMorningOpen)
        return(
            <li className="slots__item-description-item slots__item-description-item--coach">
                <div className="slots__item-description-item-label">{playersLabel}</div>
                <div className="slots__item-description-item-value">{this.state.game.totalPlayersWithPaymentNum} / {this.state.game.numberOfPlayers}</div>
            </li>
        )
    else
        return(
            <li className="slots__item-description-item slots__item-description-item--coach">
                <div className="slots__item-description-item-label">{playersLabel}</div>
                <div className="slots__item-description-item-value">{this.state.game.totalPlayersNum} / {this.state.game.numberOfPlayers}</div>
            </li>
        )
  }


  TournamentLinkButton = ()  =>{
    if (this.state.game.eventType === 'COMPETITION')
        if (this.state.game.isUserPaid)
            return (<a href={"/game/"+this.state.game.id}><button className="slots__item-record btn btn-danger">К турниру</button></a>)
        else
            return <a href={"/game/"+this.state.game.id}><button className="slots__item-record btn btn-primary">К турниру</button></a>
    }

  Tren = ()  =>{
    if (this.state.game.eventType == 'TRAINING')

        return (<li className="slots__item-description-item slots__item-description-item--coach slots__item-description-item--trainer">
                            <div className="slots__item-description-item-label">Тренер</div>
                            <div className="slots__item-description-item-value">{this.props.game.coach}</div>
                        </li>)
    else
        return
    }

  Status = () => {
    const { eventType, status } = this.props.game;
    let statusText;

    // Проверяем, отменены ли тренировка или соревнование
    if (eventType == 'TRAINING' && status == 'CANCELLED') {
        statusText = 'Отменена';
    } else if (eventType == 'COMPETITION' && status == 'CANCELLED') {
        statusText = 'Отменен';
    }

    // Если statusText не определен, то статус игры не "CANCELLED" для определенного типа
    if (statusText) {
        return (
            <li className="game__description-item game__description-item--status">
                <div className="game__description-item-label">Статус</div>
                <div className="game__description-item-value">
                    <font color="red">{statusText}</font>
                </div>
            </li>
        );
    }

    // Возвращаем null или другой JSX, если статус игры не отменен для TRAINING или COMPETITION
    return null;
}


    SEX_LABELS = {
            MEN   : "Мужчины",
            WOMEN : "Девушки",
            MIXT  : "Любой"
    };

    sex_label = () => {
    if(this.props.game.isMenLimited)
        return this.SEX_LABELS.MEN
    if(this.props.game.isWomenLimited)
        return this.SEX_LABELS.WOMEN
    return this.SEX_LABELS.MIXT
    }

  openEmailPopup = () => {
    this.setState({ showEmailPopup: true }, () => {
      document.body.style.overflow = 'hidden';
    });
  }

  closeEmailPopup = () => {
    this.setState({ showEmailPopup: false }, () => {
      document.body.style.overflow = 'auto';
    });
  }

  TimeFrame = () => {
    const parts = (this.state.game.timeFrame || '').split(' - ');

    if (parts.length !== 2) {
      return this.state.game.timeFrame;
    }

    return (
      <>
        <span className="time-frame-stack time-frame-stack--desktop">
          <span>{parts[0]}</span>
          <span className="time-frame-stack__separator">-</span>
          <span>{parts[1]}</span>
        </span>
        <span className="time-frame-stack-mobile">{this.state.game.timeFrame}</span>
      </>
    );
  }

  Weather = () => {
    const weather = this.state.game.weather;
    if (!weather) {
      return null;
    }

    return (
      <li className="slots__item-description-item slots__item-description-item--weather">
        <div className="slots__item-description-item-label">Погода</div>
        <div className="slots__item-description-item-value">{weather.temperature}°C</div>
      </li>
    );
  }

  ShortPlace = () => {
    return this.state.game.playingField && this.state.game.playingField.startsWith('Улица') ? 'Улица' : 'Внутри';
  }

  WeatherSummary = () => {
    const weather = this.state.game.weather;
    if (!weather) {
      return null;
    }

    return (
      <>
        <span className="slots__item-summary-weather">
          {weather.icon_url ? (
            <img className="slots__item-summary-weather-icon" src={weather.icon_url} alt="" />
          ) : (
            <i className="fas fa-thermometer-half" aria-hidden="true"></i>
          )}
          {weather.temperature}°C
        </span>
        <span className="slots__item-summary-separator">·</span>
      </>
    );
  }

  GameSummary = () => {
    return (
      <div className="slots__item-summary">
        <div className="slots__item-summary-time">{this.state.game.timeFrame}</div>
        <div className="slots__item-summary-meta">
          {this.WeatherSummary()}
          <span>{this.ShortPlace()}</span>
          <span className="slots__item-summary-separator">·</span>
          <span>{this.state.game.price} ₽</span>
        </div>
      </div>
    );
  }

  render() {
    if(this.state.game.eventType != 'COMPETITION')
        return (
            <React.Fragment>
                {this.state.game.eventType === 'GAME' ? (
                    this.GameSummary()
                ) : (
                    <ul className="slots__item-description">
                        <li className="slots__item-description-item slots__item-description-item--time">
                            <div className="slots__item-description-item-label">Время</div>
                            <div className="slots__item-description-item-value">{this.TimeFrame()}</div>
                        </li>
                        {this.Weather()}
                        <li className="slots__item-description-item slots__item-description-item--place">
                            <div className="slots__item-description-item-label">Место</div>
                            <div
                              className={`slots__item-description-item-value${this.state.game.playingField && this.state.game.playingField.startsWith('Улица') ? ' field--outdoor' : ''}`}
                            >
                              {this.state.game.playingField}
                            </div>
                        </li>

                        {this.Status()}

                        {(this.state.game.eventType === 'COMPETITION' || this.state.game.eventType === 'TRAINING') && (
                            <>


                                <li className="slots__item-description-item slots__item-description-item--sex">
                                    <div className="slots__item-description-item-label">Пол</div>
                                    <div className="slots__item-description-item-value">{this.sex_label()}</div>
                                </li>

                                <li className="slots__item-description-item slots__item-description-item--level">
                                    <div className="slots__item-description-item-label">Уровень</div>
                                    <div className="slots__item-description-item-value">{this.state.game.skill}</div>
                                </li>
                            </>
                        )}

                        {this.Tren()}
                        <li className="slots__item-description-item slots__item-description-item--price">
                            <div className="slots__item-description-item-label">Стоимость</div>
                            <div className="slots__item-description-item-value">{this.state.game.price}</div>
                        </li>
                    </ul>
                )}

                <PlayersList game={this.state.game} />
                {this.addActionButtons()}
                <a className="slots__item-link" href={"/game/"+this.state.game.id}></a>
                <EmailPopupModal className="modal"
                  show={this.state.showEmailPopup}
                  onClose={this.closeEmailPopup}
                  onSubmit={this.handleEmailSubmit}
                >
                </EmailPopupModal>
            </React.Fragment>
        );
    else {

        var playersLabel = this.state.game.isKingOfTheHill ? "Пары участников" : "Участники";

        return(
            <React.Fragment>
                <ul className="slots__item-description">
                    <li className="slots__item-description-item slots__item-description-item--time">
                        <div className="slots__item-description-item-label">Время</div>
                        <div className="slots__item-description-item-value">{this.TimeFrame()}</div>
                    </li>
                    {this.Weather()}
                    {this.Status()}
                    {(this.state.game.eventType === 'COMPETITION' || this.state.game.eventType === 'TRAINING') && (
                        <>
                            <li className="slots__item-description-item slots__item-description-item--place">
                                <div className="slots__item-description-item-label">Место</div>
                                <div
                                  className={`slots__item-description-item-value${this.state.game.playingField && this.state.game.playingField.startsWith('Улица') ? ' field--outdoor' : ''}`}
                                >
                                  {this.state.game.playingField}
                                </div>
                            </li>

                            <li className="slots__item-description-item slots__item-description-item--sex">
                                <div className="slots__item-description-item-label">Пол</div>
                                <div className="slots__item-description-item-value">{this.sex_label()}</div>
                            </li>

                            <li className="slots__item-description-item slots__item-description-item--level">
                                <div className="slots__item-description-item-label">Уровень</div>
                                <div className="slots__item-description-item-value">{this.state.game.skill}</div>
                            </li>
                        </>
                    )}

                    {this.Tren()}
                    <li className="slots__item-description-item slots__item-description-item--price">
                        <div className="slots__item-description-item-label">Стоимость</div>
                        <div className="slots__item-description-item-value">{this.state.game.price}</div>
                    </li>
                    {this.playersBlock(playersLabel)}
                </ul>
                {this.addActionButtons()}
                {this.TournamentLinkButton()}
                <a className="slots__item-link" href={"/game/"+this.state.game.id}></a>
                <EmailPopupModal className="modal"
                  show={this.state.showEmailPopup}
                  onClose={() => this.setState({ showEmailPopup: false })}
                  onSubmit={this.handleEmailSubmit}
                >
                </EmailPopupModal>
            </React.Fragment>
        );
    }
  }
}
export default GameDetails;
